import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getIsMobile } from './getIsMobile';
import type { Location } from '@remix-run/router';

const storage: Record<string, number> = {};

type UseScrollRestorationProps = {
    buildLocationKey: (location: Location) => string | null;
};

const RESTORATION_DEBOUNCE_TIME = 500;

export const useScrollRestoration = (props: UseScrollRestorationProps) => {
    const { buildLocationKey } = props;
    const location = useLocation();
    const isMobile = getIsMobile();
    const isLastLocationDialogRef = useRef(false);

    useEffect(() => {
        if (location.state?.dialogName) {
            isLastLocationDialogRef.current = true;

            return () => {};
        }

        if (isLastLocationDialogRef.current) {
            isLastLocationDialogRef.current = false;

            return () => {};
        }

        const key = buildLocationKey(location);

        // Если ключ null, значит страница в blacklist - не восстанавливаем и не сохраняем скролл
        if (key === null) {
            return () => {};
        }

        let saveEnabled = false;
        const onWindowScroll = () => {
            if (saveEnabled) {
                storage[key] = window.scrollY;
            }
        };

        window.document.documentElement.setAttribute(
            'style',
            `height: ${String(storage[key] ?? 0)}px`,
        );
        window.scrollTo({ top: storage[key] ?? 0 });
        window.setTimeout(() => {
            window.scrollTo({ top: storage[key] ?? 0 });
            window.setTimeout(() => {
                window.document.documentElement.removeAttribute('style');
                saveEnabled = true;
            }, RESTORATION_DEBOUNCE_TIME);
        }, 0);

        window.addEventListener('scroll', onWindowScroll, { passive: true });

        return () => window.removeEventListener('scroll', onWindowScroll);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location, isMobile]);
};
